'use strict';
window._accordions = {};

class Accordion {
	constructor(domNode, singleOpens = true) {
		this.rootEl = domNode;
		this.wrapperEl = this.rootEl.closest('.accordion');
		this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

		const controlsId = this.buttonEl.getAttribute('aria-controls');
		this.contentEl = document.getElementById(controlsId);

		this.isOpen = this.buttonEl.getAttribute('aria-expanded') === 'true';
		this.singleOpens = (typeof singleOpens === 'boolean') ? singleOpens : false;

		// add event listeners
		this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
	}

	onButtonClick() {
		this.toggle(!this.isOpen);
	}

	toggle(open) {
		// don't do anything if the open state doesn't change
		if (open === this.isOpen) {
			return;
		}

		// update the internal state
		this.isOpen = open;

		// handle DOM updates
		if (open) {
			this.wrapperEl.querySelectorAll('.accordion__trigger[aria-expanded="true"]').forEach((trigger, i) => {
				if ( trigger !== this.buttonEl && typeof trigger.parentElement.accordion !== "undefined" ) {
					trigger.parentElement.accordion.close();
				}
			});
			this.contentEl.removeAttribute('hidden');
			const wrapper = this.wrapperEl;
			slideDown(this.contentEl, 300, () => {
				wrapper.dispatchEvent( new Event("accordion-open") );
				wrapper.dispatchEvent( new Event("accordion-toggle") );
			});
		}
		else {
			const wrapper = this.wrapperEl;
			slideUp(this.contentEl, 300, () =>{
				wrapper.dispatchEvent( new Event("accordion-close") );
				wrapper.dispatchEvent( new Event("accordion-toggle") );
			});
			this.contentEl.setAttribute('hidden', '');
		}
		this.buttonEl.setAttribute('aria-expanded', `${this.isOpen}`);
	}

	// Add public open and close methods for convenience
	open() {
		this.toggle(true);
	}

	close() {
		this.toggle(false);
	}
}
